import { z } from "zod";

const colorThemeSetNames = [
    "default",
    "primary",
    "secondary",
    "tertiary",
    "quaternary",
    "warning",
    "information",
    "danger",
    "textInput",
    "disabled",
] as const;
const colorThemeSetNamesZodSchema = z.enum(colorThemeSetNames);

type ColorThemeSetName = (typeof colorThemeSetNames)[number];

export { colorThemeSetNames, colorThemeSetNamesZodSchema };
export type { ColorThemeSetName };
